import { Button, StrokeIcon, usePlatformInfo } from '@acsbe/ui';

const ChooseAPlanAction = () => {
  const planBarElement = document.getElementById(
    'accessibe-widget-choose-plan-header',
  );
  if (planBarElement) {
    planBarElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

const ChoosePlanButton = () => {
  const { isMobile } = usePlatformInfo();
  return (
    <Button
      scale="primary"
      size="md"
      variant="primary"
      onClick={ChooseAPlanAction}
      data-mixpanel="choose-a-plan"
      style={{ minWidth: '140px' }}
    >
      Choose a plan <StrokeIcon name="ArrowRight" />
    </Button>
  );
};

export { ChoosePlanButton, ChooseAPlanAction };
